// 默认api
  const DefaultApi = {
  // 分享
    share: function (options, successcb, errorcb) {
    },
  // 关闭
    close: function (options, successcb, errorcb) {
    },
  // 上传图片
    uploadImg: function (options, successcb, errorcb) {
    },
  // 选择图片
    chooseImage: function (options, successcb, errorcb) {
    },
  // 跳出浏览器打开
    openBrowser: function (options, successcb, errorcb) {
    }
  }
  export default DefaultApi



// WEBPACK FOOTER //
// ./src/environment/default_api.js